import { FETCH_CONTACTS_MESSAGES } from "../types";

export const contactReducer = (
  state = { isLoading: true, data: [] },
  action
) => {
  switch (action.type) {
    case FETCH_CONTACTS_MESSAGES:
      return {
        isLoading: false,
        data: action.payload,
        filteredData: action.payload,
      };

    default:
      return state;
  }
};
